import { Instance } from "mobx-state-tree";
import { useRootStore } from "../../root/store/RootStore";
import { APIKeyManagementStore } from "./APIKeyManagementStore";

export const useAPIKeyManagementStore = (): Instance<
  typeof APIKeyManagementStore
> => useRootStore().apiKeyManagementStore;
